import { getHrTitleDisplayName } from "./hr-title.constant";

const SYSTEM_ACCESS_PERMISSION = "System Access";

/** Role labels from the HR permission matrix (spreadsheet columns). */
export const HR_ROLE_PRESET_NAMES = [
  "Director of Operations",
  "CEO",
  "Program Director",
  "Center Director",
  "Assistant Program Director",
  "Administration Assistant",
  "Administrator",
  "Center Coordinator",
  "Lobby Manager",
  "Activity Manager",
  "Medical Appointment Coordinator",
  "Medical Appointment Scheduler",
  "CNA",
  "Certified Medication Technician",
  "Spiritual Care Specialist",
  "Registered Nurse",
  "Nursing Director",
  "Nursing Manager",
  "Social Work Assistant",
  "Social Work Director",
  "Social Work Manager",
  "Transportation Manager",
  "Transportation Coordinator",
  "Medical Driver",
  "Program Assistant - Medical Driver",
  "Program Assistant - Medical Driver Lead",
  "Driver"
];

/** Role -> app permission keys. A value of 1 in the matrix means the permission is checked. */
export const HR_ROLE_PERMISSION_PRESETS = {
  "Director of Operations": [
    "System Access",
    "Dashboard",
    "Admin View",
    "View_Info Screen",
    "Edit_Info Screen",
    "View_Customer Info _Personal Info",
    "View_Customer Info _Care & Services",
    "View_Customer Info _Medical & Insurance",
    "View_Customer Info _Confidential Details",
    "View_Customer Info _Form Submission",
    "Edit_Customer Info _ Personal Info",
    "Edit_Customer Info _ Care & Services",
    "Edit_Customer Info _ Medical & Insurance",
    "Edit_Customer Info _ Confidential Details",
    "Edit_Customer Info _ Form Submission",
    "Discharge_Customer",
    "Reactivate_Customer",
    "Create_Customer",
    "Export_Customer Report",
    "View _Calendar _Medical Appointment",
    "View _Calendar _Activities",
    "View _Calendar _Attendance Notes",
    "View _Calendar _Meal Plan",
    "View _Calendar _Important Dates",
    "Edit&Create _Calendar _Medical Appointment",
    "Edit&Create _Calendar _Activities",
    "Edit&Create _Calendar _Attendance Notes",
    "Edit&Create _Calendar _Meal Plan",
    "Edit&Create _Calendar _Important Dates",
    "View_Messaging",
    "Sent_Messaging",
    "View_Messaging Template",
    "Create&Edit_Messaging Template",
    "View_Vehicle info_Basic Info",
    "View_Vehicle info_Documents",
    "View_Vehicle info_Repair Records",
    "Edit_Vehicle info_Basic Info",
    "Edit_Vehicle info_Documents",
    "Edit_Vehicle info_Repair Records",
    "Add_New Vehicle",
    "Archive_Vehicle",
    "Export_Vehicle Report",
    "View_Transportation Schedule_Route Overview",
    "Create&Edit_Transportation Schedule",
    "Export_Transportation Schedule Report",
    "View_Route Template",
    "Create&Edit_Route Template",
    "View_Driver Assignment for Appointment",
    "Edit_Driver Assignment for Appointment",
    "View_Provider Info",
    "Create & Edit _Provider Info",
    "View_Appointment Request",
    "Edit & Create_Appointment Request",
    "View_Appointment Calendar",
    "Edit & Create_Appointment Calendar",
    "View_Meal Status",
    "Edit_Meal Status",
    "View_Seating Chart",
    "Edit_Seating Chart",
    "Employee page",
    "Set Permission for Employee"
  ],
  "CEO": [
    "System Access",
    "Dashboard",
    "Admin View",
    "View_Info Screen",
    "Edit_Info Screen",
    "View_Customer Info _Personal Info",
    "View_Customer Info _Care & Services",
    "View_Customer Info _Medical & Insurance",
    "View_Customer Info _Confidential Details",
    "View_Customer Info _Form Submission",
    "Edit_Customer Info _ Personal Info",
    "Edit_Customer Info _ Care & Services",
    "Edit_Customer Info _ Medical & Insurance",
    "Edit_Customer Info _ Confidential Details",
    "Edit_Customer Info _ Form Submission",
    "Discharge_Customer",
    "Reactivate_Customer",
    "Create_Customer",
    "Export_Customer Report",
    "View _Calendar _Medical Appointment",
    "View _Calendar _Activities",
    "View _Calendar _Attendance Notes",
    "View _Calendar _Meal Plan",
    "View _Calendar _Important Dates",
    "Edit&Create _Calendar _Medical Appointment",
    "Edit&Create _Calendar _Activities",
    "Edit&Create _Calendar _Attendance Notes",
    "Edit&Create _Calendar _Meal Plan",
    "Edit&Create _Calendar _Important Dates",
    "View_Messaging",
    "Sent_Messaging",
    "View_Messaging Template",
    "Create&Edit_Messaging Template",
    "View_Vehicle info_Basic Info",
    "View_Vehicle info_Documents",
    "View_Vehicle info_Repair Records",
    "Edit_Vehicle info_Basic Info",
    "Edit_Vehicle info_Documents",
    "Edit_Vehicle info_Repair Records",
    "Add_New Vehicle",
    "Archive_Vehicle",
    "Export_Vehicle Report",
    "View_Transportation Schedule_Route Overview",
    "Create&Edit_Transportation Schedule",
    "Export_Transportation Schedule Report",
    "View_Route Template",
    "Create&Edit_Route Template",
    "View_Driver Assignment for Appointment",
    "Edit_Driver Assignment for Appointment",
    "View_Provider Info",
    "Create & Edit _Provider Info",
    "View_Appointment Request",
    "Edit & Create_Appointment Request",
    "View_Appointment Calendar",
    "Edit & Create_Appointment Calendar",
    "View_Meal Status",
    "Edit_Meal Status",
    "View_Seating Chart",
    "Edit_Seating Chart",
    "Employee page",
    "Set Permission for Employee"
  ],
  "Program Director": [
    "System Access",
    "Dashboard",
    "Admin View",
    "View_Info Screen",
    "Edit_Info Screen",
    "View_Customer Info _Personal Info",
    "View_Customer Info _Care & Services",
    "View_Customer Info _Medical & Insurance",
    "View_Customer Info _Confidential Details",
    "View_Customer Info _Form Submission",
    "Edit_Customer Info _ Personal Info",
    "Edit_Customer Info _ Care & Services",
    "Edit_Customer Info _ Medical & Insurance",
    "Edit_Customer Info _ Confidential Details",
    "Edit_Customer Info _ Form Submission",
    "Discharge_Customer",
    "Reactivate_Customer",
    "Create_Customer",
    "Export_Customer Report",
    "View _Calendar _Medical Appointment",
    "View _Calendar _Activities",
    "View _Calendar _Attendance Notes",
    "View _Calendar _Meal Plan",
    "View _Calendar _Important Dates",
    "Edit&Create _Calendar _Medical Appointment",
    "Edit&Create _Calendar _Activities",
    "Edit&Create _Calendar _Attendance Notes",
    "Edit&Create _Calendar _Meal Plan",
    "Edit&Create _Calendar _Important Dates",
    "View_Messaging",
    "Sent_Messaging",
    "View_Messaging Template",
    "Create&Edit_Messaging Template",
    "View_Vehicle info_Basic Info",
    "View_Vehicle info_Documents",
    "View_Vehicle info_Repair Records",
    "Edit_Vehicle info_Basic Info",
    "Edit_Vehicle info_Documents",
    "Edit_Vehicle info_Repair Records",
    "Add_New Vehicle",
    "Archive_Vehicle",
    "Export_Vehicle Report",
    "View_Transportation Schedule_Route Overview",
    "Create&Edit_Transportation Schedule",
    "Export_Transportation Schedule Report",
    "View_Route Template",
    "Create&Edit_Route Template",
    "View_Driver Assignment for Appointment",
    "Edit_Driver Assignment for Appointment",
    "View_Provider Info",
    "Create & Edit _Provider Info",
    "View_Appointment Request",
    "Edit & Create_Appointment Request",
    "View_Appointment Calendar",
    "Edit & Create_Appointment Calendar",
    "View_Meal Status",
    "Edit_Meal Status",
    "View_Seating Chart",
    "Edit_Seating Chart",
    "Employee page",
    "Set Permission for Employee"
  ],
  "Center Director": [
    "System Access",
    "Dashboard",
    "Admin View",
    "View_Info Screen",
    "Edit_Info Screen",
    "View_Customer Info _Personal Info",
    "View_Customer Info _Care & Services",
    "View_Customer Info _Medical & Insurance",
    "View_Customer Info _Confidential Details",
    "View_Customer Info _Form Submission",
    "Edit_Customer Info _ Personal Info",
    "Edit_Customer Info _ Care & Services",
    "Edit_Customer Info _ Medical & Insurance",
    "Edit_Customer Info _ Confidential Details",
    "Edit_Customer Info _ Form Submission",
    "Discharge_Customer",
    "Reactivate_Customer",
    "Create_Customer",
    "Export_Customer Report",
    "View _Calendar _Medical Appointment",
    "View _Calendar _Activities",
    "View _Calendar _Attendance Notes",
    "View _Calendar _Meal Plan",
    "View _Calendar _Important Dates",
    "Edit&Create _Calendar _Medical Appointment",
    "Edit&Create _Calendar _Activities",
    "Edit&Create _Calendar _Attendance Notes",
    "Edit&Create _Calendar _Meal Plan",
    "Edit&Create _Calendar _Important Dates",
    "View_Messaging",
    "Sent_Messaging",
    "View_Messaging Template",
    "Create&Edit_Messaging Template",
    "View_Vehicle info_Basic Info",
    "View_Vehicle info_Documents",
    "View_Vehicle info_Repair Records",
    "Edit_Vehicle info_Basic Info",
    "Edit_Vehicle info_Documents",
    "Edit_Vehicle info_Repair Records",
    "Add_New Vehicle",
    "Archive_Vehicle",
    "Export_Vehicle Report",
    "View_Transportation Schedule_Route Overview",
    "Create&Edit_Transportation Schedule",
    "Export_Transportation Schedule Report",
    "View_Route Template",
    "Create&Edit_Route Template",
    "View_Driver Assignment for Appointment",
    "Edit_Driver Assignment for Appointment",
    "View_Provider Info",
    "Create & Edit _Provider Info",
    "View_Appointment Request",
    "Edit & Create_Appointment Request",
    "View_Appointment Calendar",
    "Edit & Create_Appointment Calendar",
    "View_Meal Status",
    "Edit_Meal Status",
    "View_Seating Chart",
    "Edit_Seating Chart",
    "Employee page",
    "Set Permission for Employee"
  ],
  "Assistant Program Director": [
    "System Access",
    "Dashboard",
    "View_Info Screen",
    "Edit_Info Screen",
    "View_Customer Info _Personal Info",
    "View_Customer Info _Care & Services",
    "View_Customer Info _Medical & Insurance",
    "View_Customer Info _Confidential Details",
    "View_Customer Info _Form Submission",
    "Edit_Customer Info _ Personal Info",
    "Edit_Customer Info _ Care & Services",
    "Edit_Customer Info _ Medical & Insurance",
    "Edit_Customer Info _ Confidential Details",
    "Edit_Customer Info _ Form Submission",
    "Discharge_Customer",
    "Reactivate_Customer",
    "Create_Customer",
    "Export_Customer Report",
    "View _Calendar _Medical Appointment",
    "View _Calendar _Activities",
    "View _Calendar _Attendance Notes",
    "View _Calendar _Meal Plan",
    "View _Calendar _Important Dates",
    "Edit&Create _Calendar _Medical Appointment",
    "Edit&Create _Calendar _Activities",
    "Edit&Create _Calendar _Attendance Notes",
    "Edit&Create _Calendar _Meal Plan",
    "Edit&Create _Calendar _Important Dates",
    "View_Driver Assignment for Appointment",
    "View_Provider Info",
    "Create & Edit _Provider Info",
    "View_Appointment Request",
    "Edit & Create_Appointment Request",
    "View_Appointment Calendar",
    "Edit & Create_Appointment Calendar"
  ],
  "Administration Assistant": [
    "System Access",
    "Dashboard",
    "View_Info Screen",
    "Edit_Info Screen",
    "View_Customer Info _Personal Info",
    "Edit_Customer Info _ Personal Info",
    "View _Calendar _Medical Appointment",
    "View _Calendar _Activities",
    "View _Calendar _Attendance Notes",
    "View _Calendar _Meal Plan",
    "View _Calendar _Important Dates"
  ],
  "Administrator": [
    "System Access",
    "Dashboard",
    "View_Info Screen",
    "Edit_Info Screen",
    "View_Customer Info _Personal Info",
    "Edit_Customer Info _ Personal Info",
    "View _Calendar _Medical Appointment",
    "View _Calendar _Activities",
    "View _Calendar _Attendance Notes",
    "View _Calendar _Meal Plan",
    "View _Calendar _Important Dates"
  ],
  "Center Coordinator": [
    "System Access",
    "Dashboard",
    "View_Info Screen",
    "Edit_Info Screen",
    "View_Customer Info _Personal Info",
    "View_Customer Info _Care & Services",
    "View_Customer Info _Medical & Insurance",
    "View _Calendar _Medical Appointment",
    "View _Calendar _Activities",
    "View _Calendar _Attendance Notes",
    "View _Calendar _Meal Plan",
    "View _Calendar _Important Dates"
  ],
  "Lobby Manager": [
    "System Access",
    "View_Info Screen",
    "View _Calendar _Meal Plan",
    "Edit&Create _Calendar _Meal Plan",
    "View_Meal Status",
    "Edit_Meal Status",
    "View_Seating Chart",
    "Edit_Seating Chart"
  ],
  "Activity Manager": [
    "System Access",
    "View_Info Screen",
    "View _Calendar _Activities",
    "View _Calendar _Important Dates",
    "Edit&Create _Calendar _Activities"
  ],
  "Medical Appointment Coordinator": [
    "System Access",
    "View_Info Screen",
    "View_Customer Info _Personal Info",
    "View _Calendar _Medical Appointment",
    "Edit&Create _Calendar _Medical Appointment",
    "View_Driver Assignment for Appointment",
    "View_Provider Info",
    "Create & Edit _Provider Info",
    "View_Appointment Request",
    "Edit & Create_Appointment Request",
    "View_Appointment Calendar",
    "Edit & Create_Appointment Calendar"
  ],
  "Medical Appointment Scheduler": [
    "System Access",
    "View_Info Screen",
    "View_Customer Info _Personal Info",
    "View _Calendar _Medical Appointment",
    "Edit&Create _Calendar _Medical Appointment",
    "View_Driver Assignment for Appointment",
    "View_Provider Info",
    "Create & Edit _Provider Info",
    "View_Appointment Request",
    "Edit & Create_Appointment Request",
    "View_Appointment Calendar",
    "Edit & Create_Appointment Calendar"
  ],
  "CNA": [
    "System Access",
    "View_Info Screen",
    "View_Customer Info _Personal Info",
    "View _Calendar _Medical Appointment",
    "Edit&Create _Calendar _Medical Appointment",
    "View_Driver Assignment for Appointment",
    "View_Provider Info",
    "Create & Edit _Provider Info",
    "View_Appointment Request",
    "Edit & Create_Appointment Request",
    "View_Appointment Calendar",
    "Edit & Create_Appointment Calendar"
  ],
  "Certified Medication Technician": [
    "System Access",
    "View_Info Screen",
    "View_Customer Info _Personal Info",
    "View _Calendar _Medical Appointment",
    "Edit&Create _Calendar _Medical Appointment",
    "View_Driver Assignment for Appointment",
    "View_Provider Info",
    "Create & Edit _Provider Info",
    "View_Appointment Request",
    "Edit & Create_Appointment Request",
    "View_Appointment Calendar",
    "Edit & Create_Appointment Calendar"
  ],
  "Spiritual Care Specialist": [
    "System Access",
    "View_Info Screen",
    "View_Customer Info _Personal Info",
    "View _Calendar _Medical Appointment",
    "Edit&Create _Calendar _Medical Appointment",
    "View_Driver Assignment for Appointment",
    "View_Provider Info",
    "Create & Edit _Provider Info",
    "View_Appointment Request",
    "Edit & Create_Appointment Request",
    "View_Appointment Calendar",
    "Edit & Create_Appointment Calendar"
  ],
  "Registered Nurse": [
    "System Access",
    "View_Info Screen",
    "View_Customer Info _Personal Info",
    "View _Calendar _Medical Appointment",
    "Edit&Create _Calendar _Medical Appointment",
    "View_Driver Assignment for Appointment",
    "View_Provider Info",
    "Create & Edit _Provider Info",
    "View_Appointment Request",
    "Edit & Create_Appointment Request",
    "View_Appointment Calendar",
    "Edit & Create_Appointment Calendar"
  ],
  "Nursing Director": [
    "System Access",
    "Dashboard",
    "View_Info Screen",
    "View_Customer Info _Personal Info",
    "View_Customer Info _Care & Services",
    "View_Customer Info _Medical & Insurance",
    "View_Customer Info _Confidential Details",
    "View_Customer Info _Form Submission",
    "Edit_Customer Info _ Personal Info",
    "Edit_Customer Info _ Care & Services",
    "Edit_Customer Info _ Medical & Insurance",
    "Edit_Customer Info _ Confidential Details",
    "Edit_Customer Info _ Form Submission",
    "Discharge_Customer",
    "Reactivate_Customer",
    "Create_Customer",
    "Export_Customer Report",
    "View _Calendar _Medical Appointment",
    "View _Calendar _Activities",
    "View _Calendar _Attendance Notes",
    "View _Calendar _Meal Plan",
    "View _Calendar _Important Dates",
    "Edit&Create _Calendar _Medical Appointment",
    "View_Driver Assignment for Appointment",
    "View_Provider Info",
    "Create & Edit _Provider Info",
    "View_Appointment Request",
    "Edit & Create_Appointment Request",
    "View_Appointment Calendar",
    "Edit & Create_Appointment Calendar"
  ],
  "Nursing Manager": [
    "System Access",
    "Dashboard",
    "View_Info Screen",
    "View_Customer Info _Personal Info",
    "View_Customer Info _Care & Services",
    "View_Customer Info _Medical & Insurance",
    "View_Customer Info _Confidential Details",
    "View_Customer Info _Form Submission",
    "Edit_Customer Info _ Personal Info",
    "Edit_Customer Info _ Care & Services",
    "Edit_Customer Info _ Medical & Insurance",
    "Edit_Customer Info _ Confidential Details",
    "Edit_Customer Info _ Form Submission",
    "Discharge_Customer",
    "Reactivate_Customer",
    "Create_Customer",
    "Export_Customer Report",
    "View _Calendar _Medical Appointment",
    "View _Calendar _Activities",
    "View _Calendar _Attendance Notes",
    "View _Calendar _Meal Plan",
    "View _Calendar _Important Dates",
    "Edit&Create _Calendar _Medical Appointment",
    "View_Driver Assignment for Appointment",
    "View_Provider Info",
    "Create & Edit _Provider Info",
    "View_Appointment Request",
    "Edit & Create_Appointment Request",
    "View_Appointment Calendar",
    "Edit & Create_Appointment Calendar"
  ],
  "Social Work Assistant": [
    "System Access",
    "View_Customer Info _Personal Info"
  ],
  "Social Work Director": [
    "System Access",
    "View_Customer Info _Personal Info"
  ],
  "Social Work Manager": [
    "System Access",
    "View_Customer Info _Personal Info"
  ],
  "Transportation Manager": [
    "System Access",
    "Dashboard",
    "View_Info Screen",
    "View_Customer Info _Personal Info",
    "View_Customer Info _Care & Services",
    "Edit_Customer Info _ Personal Info",
    "Edit_Customer Info _ Care & Services",
    "View_Vehicle info_Basic Info",
    "View_Vehicle info_Documents",
    "View_Vehicle info_Repair Records",
    "Edit_Vehicle info_Basic Info",
    "Edit_Vehicle info_Documents",
    "Edit_Vehicle info_Repair Records",
    "Add_New Vehicle",
    "Archive_Vehicle",
    "Export_Vehicle Report",
    "View_Transportation Schedule_Route Overview",
    "Create&Edit_Transportation Schedule",
    "Export_Transportation Schedule Report",
    "isDriver",
    "View_Route Template",
    "Create&Edit_Route Template",
    "View_Driver Assignment for Appointment",
    "Edit_Driver Assignment for Appointment",
    "View_Meal Status",
    "View_Seating Chart"
  ],
  "Transportation Coordinator": [
    "System Access",
    "Dashboard",
    "View_Info Screen",
    "View_Customer Info _Personal Info",
    "View_Customer Info _Care & Services",
    "Edit_Customer Info _ Personal Info",
    "Edit_Customer Info _ Care & Services",
    "View_Vehicle info_Basic Info",
    "View_Vehicle info_Documents",
    "View_Vehicle info_Repair Records",
    "Edit_Vehicle info_Basic Info",
    "Edit_Vehicle info_Documents",
    "Edit_Vehicle info_Repair Records",
    "Add_New Vehicle",
    "Archive_Vehicle",
    "Export_Vehicle Report",
    "View_Transportation Schedule_Route Overview",
    "Create&Edit_Transportation Schedule",
    "Export_Transportation Schedule Report",
    "isDriver",
    "View_Route Template",
    "Create&Edit_Route Template",
    "View_Driver Assignment for Appointment",
    "Edit_Driver Assignment for Appointment",
    "View_Meal Status",
    "View_Seating Chart"
  ],
  "Medical Driver": [
    "isDriver"
  ],
  "Program Assistant - Medical Driver": [
    "isDriver"
  ],
  "Program Assistant - Medical Driver Lead": [
    "isDriver"
  ],
  "Driver": [
    "isDriver"
  ]
};

function normalizeRoleKey(value) {
  return `${value ?? ""}`
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "");
}

export function getPermissionsForHrRole(roleName) {
  const preset = HR_ROLE_PERMISSION_PRESETS[roleName];
  if (!Array.isArray(preset)) {
    return [SYSTEM_ACCESS_PERMISSION];
  }
  return Array.from(new Set([SYSTEM_ACCESS_PERMISSION, ...preset]));
}

/** Match an HR title code or display name to a spreadsheet role column. */
export function matchHrRolePresetName(titleValue) {
  const display = getHrTitleDisplayName(titleValue);
  const candidates = [`${titleValue ?? ""}`.trim(), display].filter(Boolean);
  for (const candidate of candidates) {
    if (HR_ROLE_PERMISSION_PRESETS[candidate]) return candidate;
  }
  const normalizedCandidates = candidates.map(normalizeRoleKey);
  const matched = HR_ROLE_PRESET_NAMES.find((role) =>
    normalizedCandidates.includes(normalizeRoleKey(role))
  );
  return matched || "";
}
